import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { serviceurl } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class AuthServices {

  constructor(private http: HttpClient) { }

  Register(userdata: any) {
    return this.http.post(serviceurl + 'register/', userdata);
  }

  Login(data: any) {
    return this.http.post(serviceurl + 'Get/userdetails/byuserid/', data);
  }

  userUpdateData(data, userId: number) {
    return this.http.put(serviceurl + 'user/userupdateapi/' + userId + '/', data)
  }

  currentUserData(user_id: number | string) {
    return this.http.get(serviceurl + 'api/user/profile/' + user_id + '/');
  }

  getAccountDetails(user_id: number | string) {
    return this.http.get(serviceurl + 'api/user/account-details/' + user_id + '/');
  }
}
